"use client"

import Script from "next/script"
import { useSyncExternalStore } from "react"

import { getAnalyticsMode } from "@/lib/analytics-mode"

const subscribe = () => () => undefined

/** HTML先頭の判定後にロードする。社内確認・プレビューはGoogleへ送らない。 */
export function GoogleAnalytics({ gaId }: { gaId: string }) {
  const mode = useSyncExternalStore(
    subscribe,
    getAnalyticsMode,
    () => "pending",
  )
  if (mode === "internal") {
    return (
      <aside
        aria-label="社内確認モード"
        className="fixed inset-x-0 bottom-0 z-[100] border-t border-black bg-yellow-100 px-4 py-2 text-center text-sm text-black"
      >
        社内確認モード：アクセスは集計対象外です。送信メールには社内テストと表示されます。
        {window.__yoshinaniAnalyticsPersistent === false &&
          " 設定を保存できないため、再訪時は社内確認リンクを開いてください。"}{" "}
        {/* フルロードで初期計測設定を切り替える。 */}
        <a href="/?analytics=reset" className="underline underline-offset-4">
          解除してトップへ
        </a>
      </aside>
    )
  }
  if (mode !== "external") return null
  return (
    <Script
      id="ga-gtag"
      strategy="lazyOnload"
      src={`https://www.googletagmanager.com/gtag/js?id=${gaId}`}
    />
  )
}
